import { request } from '../../utils/request';

export type ProductDiscountRecord = {
  id: number;
  product_id: number;
  discount_percentage: number;
  min_quantity_range: number;
  max_quantity_range: number | null;
};

export const getProductDiscounts = (
  productId: number,
  authToken: string
): Promise<ProductDiscountRecord[]> =>
  request({
    method: 'GET',
    url: `/products/${productId}/discounts`,
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    callback: undefined,
    onError: (err) => {
      throw err;
    },
  });
